import {ReactElement} from "react";
import {RendererProps} from "../RendererProps";
import {ensureNotObject} from "../common";

export function RenderActivateBudgetYear(props: RendererProps): ReactElement {
    const budgetYear = props.variables["budgetYear"];

    return <div>Activated: {ensureNotObject(budgetYear)}</div>;
}